import { Suspense, useMemo } from "react";
import { Grid2 } from "@mui/material";
import Tabla from "../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../components/ui/materialui/tableHeader";
import { useDataFetch } from "../../../hooks/useDataFetch2";
import { useColumnSolicitudesPrepago } from "../utils/columnsSolicitudesPrepago";
import MButton from "../../../components/inputs/yup/materialui/mButton";
import { StateViewInterface } from "../interfaces/stateViews.interface";
import { exportExcel } from "../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { EstadoSolicitudPrepago, TipoFuncionalidad } from "../../../utils/enums";
import { PermissionGuard } from "../../../components/auth/ProtectedRoute";

const urlTabla = `siscred-api-cartera-total/v1/prepago/obtener-liquidacion`;

interface Props {
    idMutuo: string;
    setViewToShow: (nameView: keyof StateViewInterface) => void;
    setIdSolicitud: (idSolicitud: number) => void;
    isDesactivado?: boolean;
}

const TableSolicitudesGeneradas = ({ idMutuo, setViewToShow, setIdSolicitud, isDesactivado }: Props) => {

    const params = new URLSearchParams();
    params.set("mutuoId", idMutuo.toString());
    params.set("estados", EstadoSolicitudPrepago.GENERADA);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );

    const irALiquidarSolicitud = (idSolicitud: number) => {
        setIdSolicitud(idSolicitud);
        setViewToShow("showGenerarLiquidacion");
    }

    const { COLUMNS } = useColumnSolicitudesPrepago({ controlTabla: dataTable, irALiquidarSolicitud, isDesactivado});
    const columns = useMemo(() => COLUMNS, [dataTable]);

    return (
        <Suspense>
            <Tabla
                columns={columns}
                control={dataTable}
                url={urlTabla}
                titulo={
                    <TableHeader
                        title=""
                        control={dataTable}
                        button={
                            <Grid2 container spacing={1} sx={{ justifyContent: "flex-end", textAlign: "right" }}>
                                <MButton
                                    type="button"
                                    variant='contained'
                                    color='primary'
                                    disabled={isDesactivado}
                                    onClick={() => setViewToShow('showGenerarSolicitud')}
                                >
                                    Generar Solicitud
                                </MButton>
                            </Grid2>
                        }
                        buttonExport={
                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                            <MButton
                                type="button"
                                variant="outlined"
                                onClick={() => exportExcel(dataTable.data, columns, "solicitudesPrepago")}
                                startIcon={<SummarizeTwoToneIcon />}
                            >
                                Exportar
                            </MButton>
                            </PermissionGuard>
                        }
                    />
                }
            />
        </Suspense>
    )
}

export default TableSolicitudesGeneradas;